import { Avatar, Divider, Grid, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleOutlinedAlert, RedWarning } from 'Images';
import { expiredDays, isExpired } from 'Utils';

interface IWarningWithExpiredDate {
  date: string;
  xs?: number;
}
export const WarningWithExpiredDate = (props: IWarningWithExpiredDate) => {
  const isDesktop = useIsDesktop();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );

  const expiredDaysData = expiredDays(new Date(props.date));

  const isExpiredDate = isExpired(new Date(props.date));
  if (!isExpiredDate) return null;

  return isDesktop ? (
    <>
      <Grid gap={1} mt={1} item container xs={props.xs} alignItems='center'>
        <Avatar
          src={PurpleOutlinedAlert}
          alt=''
          sx={{ width: '16px', height: '16px' }}
        />
        <Typography variant='body6'>
          {expiredDaysData.isFuture
            ? `${dictionary.leftMore} ${expiredDaysData.days} ${dictionary.days}`
            : dictionary.expired}
        </Typography>
      </Grid>
    </>
  ) : (
    <>
      <Divider
        aria-hidden='true'
        sx={{
          margin: '20px 0',
          borderColor: 'primary.shade_100',
          width: '100%',
        }}
      />
      <Stack flexDirection={'row'} alignItems={'center'} gap={'4px'}>
        <Avatar
          src={expiredDaysData.isFuture ? PurpleOutlinedAlert : RedWarning}
          alt={''}
          sx={{ width: '16px', height: '16px' }}
        />
        {expiredDaysData.isFuture ? (
          <Typography
            variant='body7'
            sx={{ lineHeight: '20px', fontSize: '16px' }}
          >
            {`${dictionary.leftMore} `}
            <Typography variant='body7' component='span'>
              {expiredDaysData.days}
            </Typography>
            {` ${dictionary.days} ${dictionary.endPeriod}`}
          </Typography>
        ) : (
          <>
            <Typography
              variant='body6'
              color='#E12D2D'
              sx={{ lineHeight: '20px', fontSize: '16px' }}
            >
              {`${dictionary.expired}`}
            </Typography>
          </>
        )}
      </Stack>
    </>
  );
};
